module.exports = __webpack_public_path__ + "media/Video 140b.cc677892.mp4";